// // Add Up Redux Slices Here
// // create redux slice function as reducer

// // Every Page has their own redux slice function
import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import wishlistService from 'service/wishlist';
import { trackJourney } from 'telemetry/journey';

export const wishlistSlice = createSlice({
  name: 'wishlist',
  initialState: {
    wishlist: [],
    totalWishlistItems: 0,
    loading: false,
    isFetched: false
  },
  reducers: {
    setWishlist: (state, action) => {
      state.wishlist = action.payload;
    },
    setTotalWishlistItems: (state, action) => {
      state.totalWishlistItems = action.payload;
    },

    // Loading handler
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setIsFetched: (state, action) => {
      state.isFetched = action.payload;
    }
  }
});

export const { setWishlist, setTotalWishlistItems, setLoading, setIsFetched } =
  wishlistSlice.actions;

export const addToWishlistSlice = (productId) => async (dispatch) => {
  const added = await wishlistService.addWishlistItem({ productId });
  trackJourney('wishlist-add', {
    outcome: added ? 'confirmed' : 'failed',
    failureCode: added ? 'none' : 'wishlist_api_failed'
  });

  if (added) {
    toast.success('Added To Wishlist');
    dispatch(getWishlistSlice());
  }
};

export const getWishlistSlice = () => async (dispatch) => {
  dispatch(setLoading(true));
  const data = await wishlistService.getWishlists();
  if (data) {
    dispatch(setWishlist(data));
    dispatch(setTotalWishlistItems(data.length));
    dispatch(setIsFetched(true));
  }
  dispatch(setLoading(false));
};

export const removeWishlistItemSlice = (productId) => async (dispatch) => {
  trackJourney('wishlist-remove', { outcome: 'attempted' });
  const deleteWishlistItem = await wishlistService.deleteWishlistItem(
    productId
  );
  trackJourney('wishlist-remove', {
    outcome: deleteWishlistItem ? 'confirmed' : 'failed',
    failureCode: deleteWishlistItem ? 'none' : 'wishlist_api_failed'
  });

  if (deleteWishlistItem) {
    toast.success('Removed From Wishlist');
    await dispatch(getWishlistSlice());
  }
};

export default wishlistSlice.reducer;
